import { Link } from "@mui/material";
import {
  createBrowserRouter,
  Navigate,
  Params,
  Link as RouterLink,
} from "react-router-dom";
import AuthTemplateFrame from "../features/auth/AuthTemplateFrame";
import EmailConfimPage from "../features/auth/confimEmail/EmailConfimPage";
import EmailConfirmErrorPage from "../features/auth/confimEmail/EmailConfirmrErorPage";
import { confirmEmailLoader } from "../features/auth/confimEmail/laoder";
import SignInPage from "../features/auth/login/SignInPage";
import { resetPasswordAction } from "../features/auth/resetPassword/createAction";
import { resetPasswordLoader } from "../features/auth/resetPassword/laoder";
import ResetPasswordPage from "../features/auth/resetPassword/ResetPasswordPage";
import MainGrid from "../features/dashboard/components/MainGrid";
import Dashboard from "../features/dashboard/Dashboard";
import JetonForm from "../features/jeton/JetonForm";
import { jetonLoader } from "../features/jeton/laoder";
import { logLoader } from "../features/log/laoder";
import LogForm from "../features/log/LogForm";
import LogDataGrid from "../features/logs/DataGrid";
import { logListLoader } from "../features/logs/laoder";
import LogsMainGrid from "../features/logs/MainGrid";
import { userAction } from "../features/user/createAction";
import { userLoader } from "../features/user/laoder";
import UserMainGrid from "../features/user/MainGrid";
import UserForm from "../features/user/UserForm";
import UserDataGrid from "../features/users/DataGrid";
import { userListLoader } from "../features/users/laoder";
import UsersMainGrid from "../features/users/MainGrid";
import AccountDeletion from "../pages/AccountDeleteInstruction";
import ErrorPage from "../pages/ErrorPage";
import ParamsTypography from "./ParamsTypography";
import PublicMainPage from "./PublicMainPage";
import PurchasesMainGrid from "../features/purchases/MainGrid";
import PurchaseDataGrid from "../features/purchases/DataGrid";
import { purchaseListLoader } from "../features/purchases/laoder";

const authRouter = createBrowserRouter([
  {
    path: "/",
    element: <Dashboard />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <MainGrid />,
      },
      {
        path: "/systemlogs",
        element: <LogsMainGrid />,
        handle: {
          crumb: () => (
            <Link to="/systemlogs" component={RouterLink} variant="body1">
              {"Loglar"}
            </Link>
          ),
        },
        children: [
          {
            index: true,
            loader: logListLoader,
            element: <LogDataGrid />,
          },
          {
            path: "/systemlogs:id",
            element: <LogsMainGrid />,
            handle: {
              crumb: (params: Readonly<Params<string>>) => (
                <ParamsTypography
                  text={`${params.id}`}
                  to={`/systemlogs/${params.id}`}
                />
              ),
            },
            children: [
              {
                index: true,
                element: <LogForm />,
                loader: logLoader,
              },
            ],
          },
        ],
      },
      {
        path: "/users",
        element: <UsersMainGrid />,
        handle: {
          crumb: () => (
            <Link to="/users" component={RouterLink} variant="body1">
              {"Kullanıcılar"}
            </Link>
          ),
        },
        children: [
          {
            index: true,
            loader: userListLoader,
            element: <UserDataGrid />,
          },
          {
            path: "/users:id",
            element: <UserMainGrid />,
            handle: {
              crumb: (params: Readonly<Params<string>>) => (
                <ParamsTypography
                  text={`${params.id}`}
                  to={`/users/${params.id}`}
                />
              ),
            },
            children: [
              {
                index: true,
                element: <UserForm />,
                action: userAction,
                loader: userLoader,
              },
              {
                path: "jeton",
                element: <JetonForm />,
                loader: jetonLoader,
              },
            ],
          },
        ],
      },
      {
        path: "/purchases",
        element: <PurchasesMainGrid />,
        handle: {
          crumb: () => (
            <Link to="/purchases" component={RouterLink} variant="body1">
              {"Siparişler"}
            </Link>
          ),
        },
        children: [
          {
            index: true,
            loader: purchaseListLoader,
            element: <PurchaseDataGrid />,
          },
          {
            path: "/purchases:id",
            element: <PurchasesMainGrid />,
            handle: {
              crumb: (params: Readonly<Params<string>>) => (
                <ParamsTypography
                  text={`${params.id}`}
                  to={`/purchases/${params.id}`}
                />
              ),
            },
            children: [
              {
                index: true,
                element: <UserForm />,
                action: userAction,
                loader: userLoader,
              },
            ],
          },
        ],
      },
      {
        path: "*",
        element: <Navigate to={"/"} />,
        errorElement: <ErrorPage />,
      },
    ],
  },
]);

const unAuthRouter = createBrowserRouter([
  {
    path: "/",
    element: <PublicMainPage />,
  },
  {
    path: "/",
    element: <AuthTemplateFrame />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "login",
        element: <SignInPage />,
        errorElement: <ErrorPage />,
      },
      {
        path: "reset-password",
        element: <ResetPasswordPage />,
        action: resetPasswordAction,
        loader: resetPasswordLoader,
        errorElement: <ErrorPage />,
      },
      {
        path: "confirm-email",
        element: <EmailConfimPage />,
        loader: confirmEmailLoader,
        errorElement: <EmailConfirmErrorPage />,
      },
      {
        path: "delete-account",
        element: <AccountDeletion />,
      },
    ],
  },
]);
export { authRouter, unAuthRouter };
